export default "__VITE_ASSET__kHKSwt8L__"